import permissions from 'constants/permissions'

const KANBAN_TASK_LIST = [
  {
    name: 'Visualizar',
    tag: permissions.KANBAN_TASKS.LIST,
  },
  {
    name: 'Criar',
    tag: permissions.KANBAN_TASKS.CREATE,
  },
  {
    name: 'Atualizar',
    tag: permissions.KANBAN_TASKS.UPDATE,
  },
  {
    name: 'Excluir',
    tag: permissions.KANBAN_TASKS.DESTROY,
  },
  {
    name: 'Finalizar',
    tag: permissions.KANBAN_TASKS.FINALIZE,
  },
]

export default KANBAN_TASK_LIST
